module.exports = __webpack_public_path__ + "img/wash-ex.791a6071.png";